export default __webpack_public_path__ + "static/media/AccountInfo.00cb7884.png";